import {
	useMatches,
	useNavigate,
	useRouterState,
} from '@tanstack/react-router';
import { useEffect } from 'react';

import { valhallaStorage } from '../../../auth/valhallaStore';
import { loginRoute } from '../../../pages/LoginPage/route';

type UseRedirectToStoredUrlAfterAuthParams = {
	hasValidTokens: boolean;
};

export const useRedirectToStoredUrlAfterAuth = ({
	hasValidTokens,
}: UseRedirectToStoredUrlAfterAuthParams) => {
	const navigate = useNavigate();
	const router = useRouterState();
	const matches = useMatches();

	const redirectURL: string = router.location.href;
	const storedRedirectURL = valhallaStorage.redirectURL.get()?.redirectURL;

	const isLoginPage = matches.some((match) => match.routeId === loginRoute.id);

	const canStoreRedirectURL =
		!isLoginPage && !storedRedirectURL && !hasValidTokens;

	if (canStoreRedirectURL) {
		valhallaStorage.redirectURL.set({ redirectURL });
	}

	useEffect(() => {
		if (hasValidTokens) {
			const redirectUrlIsDifferentThanCurrent: boolean =
				storedRedirectURL !== redirectURL;

			const redirectConditions: boolean[] = [
				!!storedRedirectURL,
				redirectUrlIsDifferentThanCurrent,
				!isLoginPage,
			];
			const canRedirect = redirectConditions.every(Boolean);

			if (canRedirect) {
				valhallaStorage.redirectURL.remove();

				navigate({ to: storedRedirectURL });
				return;
			}

			if (storedRedirectURL) {
				valhallaStorage.redirectURL.remove();
			}
		}
	}, [hasValidTokens, storedRedirectURL, redirectURL, isLoginPage, navigate]);
};
